import PropertiesSection from './properties-section.vue';

export default PropertiesSection;
